import { useEffect, useState } from "react";
import { ArrowRight, Phone, MessageCircle } from "lucide-react";
import { whatsappUrl } from "@/components/site/WhatsAppFloat";

export default function StickyCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      // Visible after 600px scroll, hide near contact form bottom
      const inFooter = y > max - 700;
      setVisible(y > 600 && !inFooter);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* MOBILE — dual bottom bar (WhatsApp + Rappel) */}
      <div
        data-testid="mobile-sticky-bar"
        aria-label="Actions rapides Solmis Habitat"
        className={`md:hidden fixed inset-x-0 bottom-0 z-50 transition-all duration-500 ${
          visible
            ? "opacity-100 translate-y-0 pointer-events-auto"
            : "opacity-0 translate-y-full pointer-events-none"
        }`}
      >
        <div className="grid grid-cols-2 gap-0 bg-white border-t border-border shadow-[0_-18px_40px_-18px_rgba(47,45,42,0.18)]">
          <a
            href={whatsappUrl()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-sticky-whatsapp"
            className="group flex items-center justify-center gap-2.5 bg-[#25D366] text-white py-4 text-sm font-semibold transition-all active:scale-[0.98]"
            aria-label="Contacter sur WhatsApp"
          >
            <MessageCircle size={18} strokeWidth={2} />
            WhatsApp
          </a>
          <a
            href="#callback"
            data-testid="mobile-sticky-callback"
            className="group flex items-center justify-center gap-2.5 bg-[hsl(var(--brand-terra))] text-white py-4 text-sm font-semibold transition-all active:scale-[0.98]"
          >
            <Phone size={16} strokeWidth={2} />
            Être rappelé&nbsp;24h
          </a>
        </div>
      </div>

      {/* DESKTOP — orange pill "Demander mon devis" (bottom-right) */}
      <a
        href="#contact"
        data-testid="sticky-cta"
        aria-label="Demander un devis gratuit"
        className={`hidden md:inline-flex fixed bottom-6 right-6 z-50 group items-center gap-3 bg-[hsl(var(--brand-terra))] text-white pl-5 pr-6 py-4 rounded-full shadow-[0_18px_40px_-12px_rgba(219,112,1,0.55)] hover:bg-[hsl(var(--brand-terra)/0.9)] transition-all duration-500 ${
          visible
            ? "opacity-100 translate-y-0 pointer-events-auto"
            : "opacity-0 translate-y-6 pointer-events-none"
        }`}
      >
        <span className="text-sm font-semibold tracking-wide">
          Demander mon devis
        </span>
        <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-white/20 ring-1 ring-white/30">
          <ArrowRight
            size={14}
            strokeWidth={2}
            className="transition-transform duration-300 group-hover:translate-x-0.5"
          />
        </span>
      </a>
    </>
  );
}
